import React, { useState, useEffect } from "react";
// import AdBanner from "../components/AdBanners"; // Component to render ads

const Contactus = () => {
  // State to manage form fields
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  // State to show success/error messages after submission
  const [statusMessage, setStatusMessage] = useState(null);
  // Loading state for submit button
  const [loading, setLoading] = useState(false);

  // Backend API URL from environment variable
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  /**
   * Effect to update Date & Time widget every second
   * Populates elements with ids: widget-date & widget-time
   */
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const dateOptions = {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
      };
      const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      const dateEl = document.getElementById("widget-date");
      const timeEl = document.getElementById("widget-time");

      if (dateEl && timeEl) {
        dateEl.textContent = now.toLocaleDateString("en-US", dateOptions);
        timeEl.textContent = now.toLocaleTimeString("en-US", timeOptions);
      }
    }, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  /**
   * Handles form input changes dynamically
   * Updates formData state based on input name attribute
   */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  /**
   * Handles form submission
   * Sends formData to backend API
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatusMessage(null);

    try {
      const response = await fetch(`${backendUrl}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        // Success message & reset form
        setStatusMessage({ type: "success", text: "Message sent successfully!" });
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        // Show error from backend
        setStatusMessage({ type: "error", text: result.error || "Failed to send message." });
      }
    } catch (error) {
      // Network or unexpected error
      setStatusMessage({ type: "error", text: "An error occurred. Please try again later." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 mt-6 lg:flex gap-6">
      {/* Left Column: Contact Form */}
      <div className="lg:w-8/12 w-full mb-10">
        <div className="bg-white p-6 rounded shadow-sm">
          <h2 className="text-2xl font-bold mb-4">Contact Us</h2>

          {/* Status Message for success/error */}
          {statusMessage && (
            <div
              className={`mb-4 p-3 rounded ${
                statusMessage.type === "success"
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {statusMessage.text}
            </div>
          )}

          {/* Contact Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name Field */}
            <div>
              <input
                type="text"
                name="name"
                className="w-full p-2 border rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-300"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email Field */}
            <div>
              <input
                type="email"
                name="email"
                className="w-full p-2 border rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-300"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Subject Field */}
            <div>
              <input
                type="text"
                name="subject"
                className="w-full p-2 border rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-300"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            {/* Message Field */}
            <div>
              <textarea
                name="message"
                rows="5"
                className="w-full p-2 border rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-300"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-black text-white px-4 py-2 rounded hover:bg-gray-700 transition-colors duration-200"
              disabled={loading} // Disable button while loading
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>

      {/* Right Column: Sidebar */}
      <aside className="lg:w-4/12 w-full mt-6 lg:mt-0">

        {/* Ad Banner 300x250 */}
        {/* <AdBanner keyId="e34bc345ee5e3a91f6b935de958d5097" width={300} height={250} delay={3000} /> */}

        {/* Date & Time Widget */}
        <div className="aside-widget p-4 mb-6 bg-white rounded shadow-sm">
          <div className="widget-header font-bold">Current Time</div>
          <div id="widget-date" className="text-sm mt-1"></div> {/* Populated by useEffect */}
          <div id="widget-time" className="text-xl"></div> {/* Populated by useEffect */}
        </div>

        {/* Optional Trending News */}
        {/* <div className="bg-gray-100 p-4 mb-6 rounded shadow-sm">
          <h3 className="text-md font-semibold mb-3">Trending</h3>
          <ul className="list-disc pl-4 text-sm space-y-2">
            {news.slice(0, 4).map((item, index) => (
              <li key={index}>{item.title}</li>
            ))}
          </ul>
        </div> */}
      </aside>
    </div>
  );
};

export default Contactus;
